import { NavigateFn } from "@tanstack/react-router";
import { bypassNextUnsavedChangesPrompt } from "@/hooks/unsaved-changes-guard";

export function handleCloseParam({
  paramToRemove,
  setSidebar,
  navigate,
}: {
  paramToRemove?: string | string[];
  setSidebar: (node: React.ReactNode | null) => void;
  navigate: NavigateFn;
}) {
  if (!paramToRemove) {
    setSidebar(null);
    return;
  }

  const paramsToRemove = Array.isArray(paramToRemove) ? paramToRemove : [paramToRemove];

  bypassNextUnsavedChangesPrompt();
  // Remove keys from the router's already-parsed search object instead of re-reading the raw URL.
  // The router JSON-encodes search values, so rebuilding from window.location.search would turn values
  // like organisation=12 into strings and re-encode them on every navigation.
  navigate({
    to: window.location.pathname,
    search: (prev: Record<string, unknown>) => {
      const next = { ...prev };
      paramsToRemove.forEach((param) => delete next[param]);
      return next;
    },
    replace: true,
  } as any);
  setSidebar(null);
}
